// extracted by mini-css-extract-plugin
export default {"text":"TextOverflowHover-module__text__QKXLL"};